export default function LogoutIcon({ ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.75 8V6.25C15.75 5.00736 14.7426 4 13.5 4L7.50001 4C6.25736 4 5.25 5.00736 5.25 6.25L5.25 17.75C5.25 18.9926 6.25736 20 7.5 20H13.5C14.7426 20 15.75 18.9926 15.75 17.75V16M18.75 15L21.75 12M21.75 12L18.75 9M21.75 12L9.00001 12"
        stroke="#0F172A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
